    /* codes for mega menu items */
      var acc = document.getElementsByClassName("accordionHeader");
      var i; 
      for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function() {
       
          /* custom fix to close opened accordions on product page*/ 
          document.querySelectorAll('.accordionHeader').forEach((details)=>{
            if(details != this)
            details.classList.remove("active");        
          });
          document.querySelectorAll('.accordionPanel').forEach((summary)=>{
            if(summary != this.nextElementSibling)
            summary.style.maxHeight = null;
          }); 
          /* fix end here */
          
       
          this.classList.toggle("active");
          var panel = this.nextElementSibling;
          if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
          } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
          } 
        });
      }




/* for nested items, making separate js so not mixed with parent closings */
      var acc2 = document.getElementsByClassName("accordionHeader2");
      var i2; 
      for (i2 = 0; i2 < acc2.length; i2++) {
        acc2[i2].addEventListener("click", function() {
       
          /* custom fix to close opened accordions on product page*/ 
          document.querySelectorAll('.accordionHeader2').forEach((details)=>{
            if(details != this)
            details.classList.remove("active");        
          });
          document.querySelectorAll('.accordionPanel2').forEach((summary)=>{
            if(summary != this.nextElementSibling)
            summary.style.maxHeight = null;
          }); 
          /* fix end here */
           
          this.classList.toggle("active");
          var panel = this.nextElementSibling;
          if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
          } else {
            panel.style.maxHeight = panel.scrollHeight + "px"; 
          }

           // now fixing parent height also as we are inside the dropdown 
           var parentElementDropdown = this.parentNode.closest('.accordionPanel'); 
              if(parentElementDropdown)
              {
                parentElementDropdown.style.maxHeight = parentElementDropdown.scrollHeight + panel.scrollHeight + "px";  
                console.log(parentElementDropdown);
                console.log(parentElementDropdown.scrollHeight);
                console.log(panel.scrollHeight)
              }  
            // fix end

          
        });
      }




